import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Navbar";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const [branches, setBranches] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [f, setF] = useState({
    first_name: "", last_name: "", email: "", password: "", phone: "",
    preferred_branch_id: sp.get("ref") ? "" : "", referral_code: sp.get("ref") || "", birthday: "", marketing_consent: false,
  });

  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register({ ...f, preferred_branch_id: f.preferred_branch_id || null });
      toast.success("Willkommen bei HELIUM! Du hast Willkommenspunkte erhalten.");
      navigate("/mein-konto");
    } catch (e2) { setErr(formatError(e2.response?.data?.detail) || e2.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Logo className="justify-center" /></div>
        <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
          <h1 className="text-2xl font-bold font-display">Konto erstellen</h1>
          <p className="text-sm text-gray-500 mt-1">Kostenlos beitreten & Willkommenspunkte sichern.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder="Vorname" data-testid="register-firstname" value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200" />
              <input required placeholder="Nachname" data-testid="register-lastname" value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} className="px-4 py-3 rounded-xl border border-gray-200" />
            </div>
            <input required type="email" placeholder="E-Mail" data-testid="register-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            <input required type="password" placeholder="Passwort" data-testid="register-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            <input placeholder="Telefon (optional)" data-testid="register-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            <div>
              <label className="text-xs text-gray-500 ml-1">Geburtstag (optional – für Geburtstagsbonus)</label>
              <input type="date" placeholder="Geburtstag" data-testid="register-birthday" value={f.birthday} onChange={(e) => setF({ ...f, birthday: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            </div>
            <select data-testid="register-branch" value={f.preferred_branch_id} onChange={(e) => setF({ ...f, preferred_branch_id: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200">
              <option value="">Bevorzugter Standort (optional)</option>
              {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
            <input placeholder="Empfehlungscode (optional)" data-testid="register-referral" value={f.referral_code} onChange={(e) => setF({ ...f, referral_code: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            <label className="flex items-start gap-2 text-sm text-gray-600">
              <input type="checkbox" data-testid="register-consent" checked={f.marketing_consent} onChange={(e) => setF({ ...f, marketing_consent: e.target.checked })} className="mt-1" />
              Ich möchte über Angebote & Neuigkeiten per E-Mail informiert werden (jederzeit widerrufbar).
            </label>
            {err && <div className="text-sm text-[#E0243A]" data-testid="register-error">{err}</div>}
            <button disabled={loading} data-testid="register-submit" className="w-full bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-3 rounded-xl disabled:opacity-60">{loading ? "Erstellen…" : "Kostenlos registrieren"}</button>
          </form>
          <div className="mt-4 text-sm text-center text-gray-500">Bereits Mitglied? <Link to="/login" className="text-[#E0243A] font-semibold">Anmelden</Link></div>
        </div>
      </div>
    </div>
  );
}
